import { useTimer } from "react-timer-hook";
import { Tooltip } from "../../../../../components";
import { abbreviateNumber } from "../../../../../utils/utils";

interface UnlockEvent {
  dateTimestamp: number;
  percentOfCirculatingSupply: number;
  unlockAmount: number;
  unlockValue: number;
  rounds: {
    name: number;
    value: number;
  }[];
}

interface UnlockEventCardProps {
  unlockEvent: UnlockEvent;
  tokenSymbol: string;
  index: number;
}

const UnlockEventCard = ({
  unlockEvent,
  tokenSymbol,
  index,
}: UnlockEventCardProps) => {
  const date = new Date(Number(unlockEvent.dateTimestamp));
  const day = date.getUTCDate();
  const month = date.toLocaleString("default", { month: "short" });
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  const {
    seconds: expirySeconds,
    minutes: expiryMinutes,
    hours: expiryHours,
    days: expiryDays,
  } = useTimer({
    expiryTimestamp: date,
    onExpire: () => {},
  });

  return (
    <div className="flex flex-col w-full p-5 gap-5 bg-[#55A6FB1A] rounded-xl">
      <div className="flex w-full justify-between items-center">
        <p className="text-[#6EB3FA] font-bold">
          {day} <span className="font-medium text-xs">{month}</span>{" "}
          <span className="font-normal text-white opacity-50 text-xs">
            {hours}:{minutes} UTC
          </span>
        </p>
        <p className="font-bold">Upcoming Event #{index + 1}</p>
      </div>
      <div className="flex justify-center rounded-lg border-[#55A6FB] border-solid border-[1px] p-2">
        <div className="flex gap-1">
          <p>
            {expiryDays.toString().padStart(2, "0")}
            <span className="text-xs text-white opacity-50">d</span>
          </p>
          <p>
            {expiryHours.toString().padStart(2, "0")}
            <span className="text-xs text-white opacity-50">h</span>
          </p>
          <p>
            {expiryMinutes.toString().padStart(2, "0")}
            <span className="text-xs text-white opacity-50">m</span>
          </p>
          <p>
            {expirySeconds.toString().padStart(2, "0")}
            <span className="text-xs text-white opacity-50">s</span>
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex justify-between items-end">
          <div className="flex flex-col gap-2">
            <span className="text-sm opacity-50">
              {unlockEvent.percentOfCirculatingSupply}% of Cir. supply
            </span>
            <p className="font-medium">
              {abbreviateNumber(unlockEvent.unlockAmount)} {tokenSymbol}
            </p>
          </div>
          <div>
            <p className="font-medium">
              {abbreviateNumber(unlockEvent.unlockValue)} USD
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between w-full bg-[#09141EE6] rounded-lg py-[6px] px-[10px]">
        <Tooltip
          text={
            <div>
              {unlockEvent.rounds.map((round, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center gap-2"
                >
                  <p className="font-medium text-sm">Round {round.name}</p>
                  <p className="font-medium text-sm">
                    {abbreviateNumber(round.value)} {tokenSymbol}
                  </p>
                </div>
              ))}
            </div>
          }
        >
          <div className="flex gap-[2px]">
            {unlockEvent.rounds.map((_, index) => (
              <div key={index} className="w-3 h-3 bg-[#C4C4C4] rounded-full" />
            ))}
          </div>
        </Tooltip>

        <p className="font-medium text-sm opacity-50">
          {unlockEvent.rounds.length} Allocations
        </p>
      </div>
    </div>
  );
};

export default UnlockEventCard;
